// extracted by mini-css-extract-plugin
export var blue = "tag-module--blue--oUpSi";
export var red = "tag-module--red--QdHgl";
export var tag = "tag-module--tag--xEbcx";